/**
 * 'dev': Is intended to be when the app is run locally using `yarn start`
 * 'uat': Is intended to be a non-production deploy of the application
 * 'prod': Is the prod deploy of the application
 */
type ENVVALUES = 'dev' | 'uat' | 'prod';

/**
 * The environment the application is currently in.
 * Reminder: This value is set at build-time
 */
export const ENV: ENVVALUES =
    (process.env.REACT_APP_ENV?.toLowerCase() as ENVVALUES) ?? 'dev';

export const BACKEND_ROOT =
    process.env.REACT_APP_NAIGS_MANAGER_URL ??
    'https://manager.naigs.novasystems.com';

export const ADMIN_URL = `${BACKEND_ROOT}/admin`;

export const API_URL = `${BACKEND_ROOT}/api/v1`;

export const OAUTH_URL = `${BACKEND_ROOT}/o`;

export const DATA_URL =
    process.env.REACT_APP_NAIGS_DATA_URL ??
    `https://data.naigs.novasystems.com`;

export const WEBSOCKET_URL =
    process.env.REACT_APP_NAIGS_WEBSOCKET_URL ??
    `wss://websocket.naigs.novasystems.com`;

export const CLIENT_ID = (() => {
    // An example of switching configs based on the environment
    // if hardcoded values can be known, but switching to an
    // authoratative environment variable if found.
    if (process.env.REACT_APP_NAIGS_CLIENT_ID)
        return process.env.REACT_APP_NAIGS_CLIENT_ID;

    if (ENV === 'prod') return 'LMFxptJ9GxDlsyG3fgjnUngE5mBvZNnxnGS0caJS';

    if (ENV === 'uat') return 'LMFxptJ9GxDlsyG3fgjnUngE5mBvZNnxnGS0caJS';

    return 'LMFxptJ9GxDlsyG3fgjnUngE5mBvZNnxnGS0caJS';
})();

export const MAPBOX_ACCESS_TOKEN = (() => {
    // An example of switching configs based on the environment
    // if hardcoded values can be known, but switching to an
    // authoratative environment variable if found.
    if (process.env.REACT_APP_MAPBOX_ACCESS_TOKEN)
        return process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
    //  Default public token
    return 'pk.eyJ1IjoibWljaGFlbC1iYXVlci1nZW9wbGV4IiwiYSI6ImNsbmpmMGw5bzA5YXoya2xzeWUzaWk2bjkifQ.JIhpcErNSy1ksA-cCKcFNA';

    // return 'sk.eyJ1IjoibWljaGFlbC1iYXVlci1nZW9wbGV4IiwiYSI6ImNsbmpmNnphZDB1aGYyanFpamFyOGU5MzcifQ.JFG5aFlDCdk94cZEOl4o4A';
})();

export const CESIUM_TOKEN = process.env.REACT_APP_NAIGS_CESIUM_TOKEN ?? '';

export const LOCALE = 'en-AU';

export const LOCALSTORAGE = {
    AUTH: 'auth',
    THEMEMODE: 'theme-mode',
};

/**
 * The time in milliseconds between attempting to refresh the auth token using a refresh token
 */
export const REFRESH_DELAY = 15 * 60_000;

/**
 * The limit of items returned by the API.
 */
export const API_LIMIT = 50;

/**
 * The Max Elevation for a Schedule which would generate a warning about potentially minor to moderate keyhole effects
 */
export const ANTENNA_KEYHOLE_WARNING_ELEVATION = 75;

/**
 * The Max Elevation for a Schedule which would generate a warning about potentially major keyhole effects
 */
export const ANTENNA_KEYHOLE_ERROR_ELEVATION = 80;
